import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'investigative-consumer-report',
  templateUrl: './investigative-consumer-report.component.html'
})
export class InvestigativeConsumerReportComponent {

  constructor() {
  }
}
